import Api from '../../base/api.typings';
import axiosConfiguration from '@/base/axios-configuration';

class UsuarioService {
    async listarTipo(query?/*: Api.Usuario.ListarTipo.Query*/): Promise<any/*Api.Usuario.ListarTipo.ResultadoDto*/> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/usuario/listarTipo', { params: query }).then(r => r.data);
    }

    async listarAcesso(query?/*: Api.Usuario.ListarAcesso.Query*/): Promise<any/*Api.Usuario.ListarAcesso.ResultadoDto*/> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/usuario/ListarAcesso', { params: query }).then(r => r.data);
    }

    async inserir(command/*: Api.Usuario.InserirEditar.Command*/): Promise<number> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/usuario/inserir', command).then(r => r.data);
    }

    async remover(command/*: Api.Usuario.Remover.Command*/) {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().delete('/api/usuario/Remover', { params: command }).then(r => r.data);
    }

    async obterPerfilUsuario(query: Api.App.Server.Usuario.ObterPerfilUsuario.Query): Promise<Api.Common.Infra.Auth.PerfilTipoUsuarioEnum> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Usuario/ObterPerfilUsuario', { params: query }).then(r => r.data);
    }

    async listarContadores(query: Api.App.Server.Usuario.ListarContadores.Query): Promise<Api.App.Server.Usuario.ListarContadores.Dto[]> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Usuario/ListarContadores', { params: query }).then(r => r.data);
    }

    async listarClientes(query: Api.App.Server.Usuario.ListarClientes.Query): Promise<Api.App.Server.Usuario.ListarClientes.Dto[]> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Usuario/ListarClientes', { params: query }).then(r => r.data);
    }

    async listar(query: Api.App.Server.Usuario.Listar.Query): Promise<Api.App.Server.Usuario.Listar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Usuario/Listar', { params: query }).then(r => r.data);
    }

    async obterParaEditar(query?: Api.App.Server.Usuario.Editar.Query): Promise<Api.App.Server.Usuario.Editar.Command> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Usuario/ObterParaEditar', { params: query }).then(e => e.data);
    }

    async editar(command: Api.App.Server.Usuario.Editar.Command): Promise<string> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().put('/api/Usuario/Editar', command);
    }

    async listarEmpresas(query: Api.App.Server.Usuario.ListarEmpresas.Query): Promise<Api.App.Server.Usuario.ListarEmpresas.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/Usuario/ListarEmpresas', { params: query }).then(r => r.data);
    }

    async listarPorEmpresa(query: Api.App.Server.Usuario.ObterUsuarioEmpresa.Query): Promise<Api.App.Server.Usuario.ObterUsuarioEmpresa.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/usuario/usuarioEmpresa', { params: query }).then(e => e.data);
    }
}

export default new UsuarioService();